import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

import { ErrorMessage, Formik, Form } from 'formik';
import FooterFormValidation from './FooterFormValidation';

import Icon from 'components/modules/Icon/Icon';
import {
  FormContainer,
  FormTitle,
  Input,
  Btn,
  BtnTitle,
  InputContainer,
  Textarea,
  Error,
} from './FooterForm.styled';

export default function FooterForm() {
  const [submittedText, setSubmittedText] = useState(null);
  const [error, setError] = useState(null);
  const {
    REACT_APP_SERVICE_ID,
    REACT_APP_TEMPLATE_FOOTER_FORM_ID,
    REACT_APP_PUBLIC_KEY,
  } = process.env;

  const onSubmit = async (values, { resetForm }) => {
    // console.log(values);

    try {
      await emailjs
        .send(
          REACT_APP_SERVICE_ID,
          REACT_APP_TEMPLATE_FOOTER_FORM_ID,
          {
            name: values.name,
            phone: values.phone,
            email: values.email,
            textarea: values.textarea,
          },
          REACT_APP_PUBLIC_KEY
        )
        .then(
          result => {
            result.status === 200 && setSubmittedText(true);
            // console.log(result.text, 'result', result);
            resetForm();
          },
          error => {
            console.log(error.text);
            setError(true);
          }
        );
    } catch (error) {
      console.log(error);
      setError(true);
    }
  };

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={{
        name: '',
        phone: '',
        email: '',
        textarea: '',
      }}
      validationSchema={FooterFormValidation}
    >
      {({ values, handleChange, handleBlur, isSubmitting }) => (
        <FormContainer>
          <FormTitle>
            <p>Contact sales</p>
          </FormTitle>

          <Form
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <InputContainer style={{ marginTop: '60px' }}>
              <Icon id={'#name'} />
              <Input
                placeholder="Name"
                name="name"
                type="text"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <Error>
                <ErrorMessage name={'name'} />
              </Error>
            </InputContainer>
            <InputContainer>
              <Icon id={'#smartphone'} />
              <Input
                placeholder="Phone"
                name="phone"
                type="text"
                value={values.phone}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <Error>
                <ErrorMessage name={'phone'} />
              </Error>
            </InputContainer>
            <InputContainer>
              <Icon id={'#email'} />
              <Input
                placeholder="E-mail"
                name="email"
                type="email"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <Error>
                <ErrorMessage name={'email'} />
              </Error>
            </InputContainer>

            <Textarea
              placeholder="Please type your questions here"
              maxLength="5000"
              id="textarea"
              name="textarea"
              value={values.textarea}
              onChange={handleChange}
              onBlur={handleBlur}
            ></Textarea>

            <Btn type="submit" disabled={isSubmitting}>
              <BtnTitle>
                {error
                  ? 'Oops! Something went wrong. Please, try again.'
                  : isSubmitting
                  ? 'Loading...'
                  : submittedText
                  ? 'Submitted, thanks!'
                  : 'Contact sales'}
              </BtnTitle>
            </Btn>
          </Form>
        </FormContainer>
      )}
    </Formik>
  );
}
